import { SiteSchedule } from '@hakimo-ui/hakimo/types';
import { ScheduleItem } from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import { getDefaultSchedule } from '../../schedule/siteSchedule';

interface ScheduleEditorProps {
  schedules: SiteSchedule[];
  onChange: (schedules: SiteSchedule[]) => void;
  error?: string | null;
}

export function ScheduleEditor({
  schedules,
  onChange,
  error,
}: ScheduleEditorProps) {
  const onAddSchedule = () => onChange([...schedules, getDefaultSchedule()]);

  const onUpdateSchedule = (index: number) => (schedule: SiteSchedule) => {
    const updated = [...schedules];
    updated[index] = schedule;
    onChange(updated);
  };

  const onDeleteSchedule = (index: number) => () => {
    onChange(schedules.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      {schedules.map((schedule, idx) => (
        <ScheduleItem
          key={idx}
          schedule={schedule}
          updateSchedule={onUpdateSchedule(idx)}
          isDeletable
          isEditing
          allowAddRange={false}
          onDelete={onDeleteSchedule(idx)}
        />
      ))}

      {error && (
        <div className="text-alert-600 dark:text-alert-400 text-sm">
          {error}
        </div>
      )}

      <Button onClick={onAddSchedule} variant="outline">
        Add Schedule
      </Button>
    </div>
  );
}
